import * as yup from 'yup'

const schema = yup.object().shape({
  isLargeScale: yup.string().required('Escolha uma opção'),
})

export default schema
